export default __webpack_public_path__ + "static/media/logo.85369177.svg";